import type {
  DataSourceTemplateDetailRaw,
  DataSourceTemplateDetailUI,
  DataSourceTemplateListRaw,
  DataSourceTemplateRow,
  PropertySchemaRow,
} from "~/features/dataSourceTemplates/types";

/** API row → table row. */
function toDataSourceTemplateRow(raw: DataSourceTemplateListRaw): DataSourceTemplateRow {
  return {
    id: raw.id,
    name: raw.name,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toDataSourceTemplateRowList(raws: readonly DataSourceTemplateListRaw[]): DataSourceTemplateRow[] {
  return raws.map(toDataSourceTemplateRow);
}

/** API detail row → detail-page view model. */
export function toDataSourceTemplateDetailUI(raw: DataSourceTemplateDetailRaw): DataSourceTemplateDetailUI {
  const associations = raw.dataSourceTemplatePropertySchemaSet[0]?.propertySchemaSet.propertySchemaAssociations ?? [];
  const propertySchemas: PropertySchemaRow[] = associations.map((a) => ({
    id: a.id,
    name: a.name,
    description: a.description ?? "",
    position: a.position,
    required: a.required,
    unique: a.unique,
    propertyTypeId: a.propertySchema.propertyTypeId,
    propertyAttributeTypeId: a.propertyAttributeTypeId ?? null,
    selectOptions: Array.isArray(a.propertySchema.selectOptions)
      ? (a.propertySchema.selectOptions as PropertySchemaRow["selectOptions"])
      : [],
    urlAllowList: Array.isArray(a.propertySchema.urlAllowList)
      ? (a.propertySchema.urlAllowList as PropertySchemaRow["urlAllowList"])
      : [],
  }));

  return {
    id: raw.id,
    name: raw.name,
    isDeactivated: Boolean(raw.deactivatedAt),
    createdAt: raw.createdAt ?? null,
    updatedAt: raw.updatedAt ?? null,
    deactivatedAt: raw.deactivatedAt ?? null,
    propertySchemas,
  };
}
